import { render } from "./Winners.vue?vue&type=template&id=7ad7feb6&scoped=true"
import script from "./Winners.vue?vue&type=script&lang=js"
export * from "./Winners.vue?vue&type=script&lang=js"

import "./Winners.vue?vue&type=style&index=0&id=7ad7feb6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ad7feb6"

export default script